(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mobile and desktop menu enhancements
  document.addEventListener('DOMContentLoaded', function() {
    // Desktop hover — mega panel navigation.
    // Uses an intent delay (80 ms) when switching panels to prevent accidental
    // activation while the cursor moves diagonally through other nav items.
    // Panels only close when the cursor leaves the entire .header__inline-menu.
    var headerNavList = document.querySelector('.header__inline-menu > ul');
    if (headerNavList) {
      var dropdownItems = headerNavList.querySelectorAll(':scope > .list-menu__item.has-dropdown');
      var switchTimer = null;
      var panelOpen = false;

      function openPanel(details) {
        clearTimeout(switchTimer);
        dropdownItems.forEach(function(item) {
          var d = item.querySelector(':scope > details');
          if (d && d !== details) d.removeAttribute('open');
        });
        details.setAttribute('open', '');
        panelOpen = true;
      }

      function closeAll() {
        clearTimeout(switchTimer);
        dropdownItems.forEach(function(item) {
          var d = item.querySelector(':scope > details');
          if (d) d.removeAttribute('open');
        });
        panelOpen = false;
      }

      dropdownItems.forEach(function(item) {
        var details = item.querySelector(':scope > details');
        item.addEventListener('mouseenter', function() {
          if (window.innerWidth < 990 || !details) return;
          clearTimeout(switchTimer);
          if (!panelOpen) {
            // First open — instant, feels responsive
            openPanel(details);
          } else {
            // Switching panels — short delay prevents diagonal-movement accidents
            switchTimer = setTimeout(function() { openPanel(details); }, 80);
          }
        });
        // Cancel a pending switch if cursor leaves before the delay fires
        item.addEventListener('mouseleave', function() { clearTimeout(switchTimer); });
      });

      // Close all panels when cursor leaves the whole nav (including the mega panels)
      var headerInlineMenu = document.querySelector('.header__inline-menu');
      if (headerInlineMenu) {
        headerInlineMenu.addEventListener('mouseleave', closeAll);
      }
    }

    // Close mega menu on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.list-menu__item.has-dropdown details[open]').forEach(function(d) {
          d.removeAttribute('open');
        });
      }
    });

    // Mobile drawer — overlay backdrop and swipe-to-close
    // Dawn's HeaderDrawer handles open/close/body-scroll/aria; we only add the overlay.
    const detailsToggle = document.getElementById('Details-menu-drawer-container');
    const menuDrawerContent = document.querySelector('.menu-drawer');

    if (detailsToggle && menuDrawerContent) {
      // Overlay is shown/hidden by CSS: details[open] .menu-drawer-overlay
      const overlay = document.createElement('div');
      overlay.classList.add('menu-drawer-overlay');
      detailsToggle.appendChild(overlay);

      // Delegate close to Dawn's HeaderDrawer via summary click (preserves animation + aria)
      function closeMobileDrawer() {
        if (detailsToggle.hasAttribute('open')) {
          const summary = detailsToggle.querySelector(':scope > summary');
          if (summary) summary.click();
        }
      }

      overlay.addEventListener('click', closeMobileDrawer);

      // X close button in drawer header
      var closeBtn = menuDrawerContent.querySelector('.menu-drawer__close-button');
      if (closeBtn) closeBtn.addEventListener('click', closeMobileDrawer);

      // Back buttons — collapse the parent submenu <details>
      menuDrawerContent.querySelectorAll('.menu-drawer__back-button').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var parentDetails = btn.closest('details');
          if (parentDetails) parentDetails.removeAttribute('open');
        });
      });

      // Swipe left to close
      let touchStartX = 0;
      menuDrawerContent.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      menuDrawerContent.addEventListener('touchmove', (e) => {
        if (touchStartX - e.changedTouches[0].screenX > 50) closeMobileDrawer();
      }, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.limit = this.dataset.limit || 4;
    this.productGrid = this.querySelector('.product-grid');
    this.loadRecentProducts();
  }

  loadRecentProducts() {
    const recentProducts = JSON.parse(localStorage.getItem('recently-viewed-products') || '[]');
    if (recentProducts.length === 0) return;

    const productHandles = recentProducts.slice(0, this.limit);
    
    Promise.all(
      productHandles.map(handle =>
        fetch(`/products/${handle}?view=card`)
          .then(response => response.text())
      )
    ).then(products => {
      this.productGrid.innerHTML = products.join('');
    });
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);

// Add current product to recently viewed
const addCurrentProduct = () => {
  const productHandle = document.querySelector('meta[property="og:url"]')?.content?.split('/products/')[1];
  if (!productHandle) return;

  const recentProducts = JSON.parse(localStorage.getItem('recently-viewed-products') || '[]');
  const updatedProducts = [
    productHandle,
    ...recentProducts.filter(handle => handle !== productHandle)
  ].slice(0, 12);

  localStorage.setItem('recently-viewed-products', JSON.stringify(updatedProducts));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addCurrentProduct);
} else {
  addCurrentProduct();
}

  } catch(e) { console.error(e); }
})();
})();
